import * as React from "react"
import type { SVGProps } from "react"
const SvgOpenEmailFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3 18.71q-.83 0-1.41-.58A2 2 0 0 1 1 16.7V4.54q.06-.72.59-1.24A2 2 0 0 1 3 2.71h16q.83 0 1.41.6.53.51.58 1.23H21v4.17a1 1 0 0 1-2 0V6.6l-6.97 4.17a2 2 0 0 1-1.03.28 2 2 0 0 1-1.02-.28L3 6.6v10.13h9a1 1 0 1 1 0 2zm.75-14h14.5L11 9.04z"
    />
    <path d="M16.18 21.54q1.17 1.17 2.82 1.17c1.65 0 2.04-.39 2.83-1.17A4 4 0 0 0 23 18.7v-3a1 1 0 0 0-.29-.7 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3 1 1 0 0 0-.29.7v3q0 .82-.59 1.42a2 2 0 0 1-1.41.58q-.83 0-1.41-.58A2 2 0 0 1 17 18.7v-4.5q0-.2.15-.35a.5.5 0 0 1 .7 0q.15.15.15.35v3.5q0 .43.29.72t.71.28c.42 0 .52-.1.71-.28a1 1 0 0 0 .29-.72v-3.5q0-1.05-.73-1.77-.72-.72-1.77-.73c-1.05 0-1.3.25-1.78.73A2.4 2.4 0 0 0 15 14.2v4.5q0 1.66 1.17 2.83Z" />
  </svg>
)
export default SvgOpenEmailFile
